import { render } from "./ChallengePerformances.vue?vue&type=template&id=4aa9b3d7"
import script from "./ChallengePerformances.vue?vue&type=script&lang=js"
export * from "./ChallengePerformances.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__